import React from "react";
import "../styles/ScreenLoading.css";
// Sesuaikan path ini dengan lokasi logo Anda
import logo from "../assets/logo_web.png"; 

const ScreenLoading = () => {
  return (
    <div className="hospital-loader-container">
      {/* Background Decor */}
      <div className="bg-gradient-orb"></div>
      
      <div className="loader-content">
        {/* LOGO SECTION WITH PULSE */}
        <div className="logo-wrapper">
          <div className="pulse-ring"></div>
          <div className="pulse-ring delay"></div>
          <img src={logo} alt="RSIA Annisa Logo" className="hospital-logo" />
        </div>

        {/* TEXT SECTION */}
        <div className="loading-text">
          <h2>RSIA ANNISA</h2>
          <p>Memuat Sistem KPI & Data...</p>
        </div>

        {/* HEARTBEAT LINE ANIMATION (SVG) */}
        <div className="heartbeat-wrapper">
          <svg
            className="heartbeat-svg"
            viewBox="0 0 500 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="heartbeat-path"
              d="M0 50 H150 L180 20 L210 80 L240 50 H500"
              stroke="#3eb7b3"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* MODERN PROGRESS BAR */}
        <div className="progress-container">
          <div className="progress-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default ScreenLoading;